/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


/** Import Main React Library Object, with Hooks */
import React, {useContext} from "react";

/** Import Redux Hook - Getter for Data from Application State Store Object */
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

/** Import Router Context - Routes URLs List */
import ApplicationRouterContext from "@Contexts/Router";
/** Import Router Interface - Router Object Type */
import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";

/** Import User Interface - Logged User Object Type */
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


/** Import Router Modules - Application Routing System */
import {Route} from "react-router-dom";


/** Import Component Children Components */
import NotAuthenticatedUserComponent from "@UIPages/NotAuthenticated"; // Not Authenticated User Component (Login, Register, etc...)
import AuthenticatedUserComponent from "@UIPages/Authenticated"; // Authenticated User Component (Dispositions, Monitory Notes, etc...)


/** @type ApplicationComponentProps - Props List for Application Main Content Component */
type ApplicationComponentProps = {};


/**
 * @visibleName Application Main Content Component
 *
 * @return JSX.Element
 */
export const ApplicationComponent: React.FC<ApplicationComponentProps> = (): JSX.Element => {

    /** @const {UserInterface | null} LOGGED_USER - Application Global State Logged User Object */
    const LOGGED_USER: LOGGED_USER_INTERFACE | null = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    /** @const {APPLICATION_ROUTER_INTERFACE} ROUTER - Application Global Routes List Object */
    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);

    /** @const {string} HOME_PAGE_URL - Router Home Page URL Address */
    const HOME_PAGE_URL: string = ROUTER?.COMMON?.HOME?.URL || "/";


    /**
     * @description render Component Content
     * @return JSX.Element
     */
    return (
        <>
        {/* Check if User is Logged (User object in / not in memory */}
        {!!LOGGED_USER && !!LOGGED_USER?.userID ?
            // User is Logged - Authenticated User Component
            <Route path={HOME_PAGE_URL} render={() => <AuthenticatedUserComponent />} />
        :
            // User is not Logged - Not Authenticated User Component
            <Route path={HOME_PAGE_URL} render={() => <NotAuthenticatedUserComponent />} />
        }
        </>
    );

};


/** @export {React.FC} Application - Application Main Content Component */
export default ApplicationComponent;
